import { useTheme } from "@mui/material/styles";
import Stack from "@mui/material/Stack";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router";
import useOffSetTop from "hooks/useOffSetTop";
import useResponsive from "hooks/useResponsive";
import c, { HEADER, NAV } from "config";
import Logo from "components/logo";
import Iconify from "components/iconify";
import { useSettingsContext } from "components/settings";
import AccountPopover from "./AccountPopover";
import NotificationsPopover from "./NotificationsPopover";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import Avatar from "@mui/material/Avatar";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import SwicthGoalDialog from "./SwicthGoalDialog";
import startIcon from "../../../assets/images/star.png";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import proicon from "../../../assets/images/proicon.png";
import { getSubjectsByStudentAsync } from "redux/async.api";
import SubjectList from "pages/Contents/Contents/SubjectList";
import { lightenColor } from "utils/colorCodeTransform";

export default function Header({ onOpenNav }) {
  const theme = useTheme();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const { subjectInfo } = location?.state || {};
  const { studentById } = useSelector((state) => state?.student);
  const [open, setOpen] = useState(false);
  const [selectSubject, setSelectSubject] = useState("");
  const [currentSubjectName, setCurrentSubjectName] = useState({});
  const { subjectLoader, subjectBy } = useSelector((state) => state?.subject);
  const { course_type, isPremium } = studentById;

  const { themeLayout } = useSettingsContext();

  const isNavHorizontal = themeLayout === "horizontal";

  const isNavMini = themeLayout === "mini";

  const isDesktop = useResponsive("up", "lg");

  const isOffset = useOffSetTop(HEADER.H_DASHBOARD_DESKTOP) && !isNavHorizontal;

  const isSubjectChpaterRoute = location?.pathname == "/app/chapters";

  useEffect(() => {
    setCurrentSubjectName({});
  }, []);

  useEffect(() => {
    if (isSubjectChpaterRoute) {
      dispatch(getSubjectsByStudentAsync({}));
    }
  }, [isSubjectChpaterRoute]);

  useEffect(() => {
    if (Object.keys(currentSubjectName).length > 0 && currentSubjectName?.id) {
      navigate("/app/chapters", {
        state: { subjectInfo: currentSubjectName },
      });
    }
  }, [currentSubjectName]);

  let rgbColorCode = location?.state?.subjectInfo?.colourCode
    ? lightenColor(location?.state?.subjectInfo?.colourCode.trim(), 60)
    : "";

  const renderContent = (
    <>
      {isDesktop && isNavHorizontal && <Logo sx={{ mr: 2.5 }} />}
      {!isDesktop && (
        <IconButton onClick={onOpenNav} sx={{ mr: 1, color: "text.primary" }}>
          <Iconify icon="eva:menu-2-fill" />
        </IconButton>
      )}

      <Stack
        flexGrow={1}
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        spacing={{ xs: 0.5, sm: 1.5 }}
      >
        {isSubjectChpaterRoute ? (
          <Box>
            <ArrowBackIcon
              sx={{ color: "#000", cursor: "pointer", mb: isOffset ? 0 : 3 }}
              onClick={() => navigate("/app/startlearning")}
            />
            {isSubjectChpaterRoute && subjectBy?.length > 0 && (
              <Box>
                <SubjectList
                  subjectInfo={subjectBy}
                  selectSubject={selectSubject}
                  setSelectSubject={setSelectSubject}
                  currentSubjectName={currentSubjectName}
                  setCurrentSubjectName={setCurrentSubjectName}
                  currentSubjectInfo={subjectInfo}
                />
              </Box>
            )}
          </Box>
        ) : (
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              width: "100%",
            }}
          >
            <Box
              sx={{
                padding: "5px 10px",
                borderRadius: "5px",
                // boxShadow: "0px 2px 10px 0px rgba(0, 0, 0, 0.25)",
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
                gap: 2,
              }}
              onClick={() => {
                setOpen(true);
              }}
            >
              <Avatar
                alt="avatar"
                src={startIcon}
                sx={{ width: 25, height: 25 }}
              />
              <Typography
                sx={{
                  fontFamily: "sans-serif",
                  color: "black",
                  fontSize: { xs: "14px", sm: "18px" },
                  fontWeight: "600",
                }}
              >
                {studentById?.goalTitle}
              </Typography>
              <ChevronRightIcon
                sx={{ color: "black", transform: "rotate(90deg)" }}
              />
            </Box>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
              }}
            >
              {course_type == "Purchase" && !isPremium && (
                <Box sx={{ mr: 2, cursor: "pointer" }}>
                  <img src={proicon} alt="pro icon" width="90px" />
                </Box>
              )}

              {/* <Typography
                      sx={{
                        fontFamily: "sans-serif",
                        color: "black",
                        fontSize: "16px",
                        fontWeight: "600",
                        display: { xs: "none", sm: "block" },
                      }}
                    >
                      Hello, {name}{" "}
                    </Typography> 
                     <NotificationsPopover sx={{ mr: 2 }} /> */}
              <AccountPopover />
            </Box>
          </Box>
        )}
      </Stack>

      <SwicthGoalDialog open={open} setOpen={setOpen} />
    </>
  );

  return (
    <AppBar
      sx={{
        // bgcolor: "primary.main",
        background: isSubjectChpaterRoute
          ? `${rgbColorCode} url(${location?.state?.subjectInfo?.banner}) repeat fixed center`
          : "#F8F9FA",
        boxShadow: "none",
        height: isSubjectChpaterRoute ? "130px" : HEADER.H_MOBILE,
        zIndex: theme.zIndex.appBar + 1,
        // borderBottom: isSubjectChpaterRoute ? "none" : "1px dashed #ccc",
        transition: theme.transitions.create(["height"], {
          duration: theme.transitions.duration.shorter,
        }),
        ...(isDesktop && {
          width: `calc(100% - ${NAV.W_DASHBOARD }px)`,
          height: isSubjectChpaterRoute ? "130px" : HEADER.H_DASHBOARD_DESKTOP,
          ...(isOffset && {
            height: HEADER.H_DASHBOARD_DESKTOP_OFFSET + 20,
          }),
          ...(isNavHorizontal && {
            width: 1,
            bgcolor: "#F8F9FA",
            height: HEADER.H_DASHBOARD_DESKTOP_OFFSET,
            borderBottom: (theme) => `dashed 1px ${theme.palette.divider}`,
          }),
          ...(isNavMini && {
            width: `calc(100% - ${NAV.W_DASHBOARD_MINI + 1}px)`,
          }),
        }),
      }}
    >
      <Toolbar
        sx={{
          height: 1,
          px: { lg: 5 },
        }}
      >
        {renderContent}
      </Toolbar>
    </AppBar>
  );
}
